import { useNavStack } from 'careand-redux/slices/ui/hooks';
import { getActiveStack, getCurrentRoute, Stacks } from 'careand-redux/slices/ui/navigation';
import { uiActions } from 'careand-redux/slices/ui/ui';
import { useAppSelector } from 'careand-redux/store';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import Icon from 'components/Utils/NewIcon';
import ProgressMessage from 'components/Utils/ProgressMessage';
import React, { FC, ReactElement, useState } from 'react';
import './style.scss';

interface TopBarProps {
  leftElement?: ReactElement;
  rightElement?: ReactElement | { icon?: string; onClick?: () => void };
  title?: string;
  hideBack?: boolean;
}

const TopBar: FC<TopBarProps> = ({ leftElement, rightElement, title, hideBack }) => {
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector((state) => state.ui.loadingData > 0);
  const activeStack = useAppSelector((state) => getActiveStack(state.navigation));
  const masterRoute = useAppSelector((state) => getCurrentRoute(state.navigation, Stacks.Master));
  const idx = useAppSelector((state) => state.navigation.stacks[activeStack].idx);
  const { pop } = useNavStack(activeStack);
  const canShowMenu = masterRoute === '/';
  const [hasBack] = useState(idx > 0 && !hideBack);

  const openMenu = () => {
    dispatch(uiActions.setSideMenu(true));
  };

  const leftIcon = hasBack ? 'chevron-left' : canShowMenu ? 'bars' : undefined;
  const leftClickHandler = hasBack ? pop : canShowMenu ? openMenu : undefined;

  let rightButton = rightElement;

  if (rightElement && ('icon' in rightElement || 'onClick' in rightElement)) {
    rightButton = <Icon src={rightElement.icon} height="20px" onClick={rightElement.onClick} />;
  } else if (!rightElement && isLoading) {
    rightButton = <ProgressMessage show={isLoading} size={15} />;
  }

  return (
    <div className="patient-top-bar">
      {leftElement || (
        <div className={'left' + (leftIcon === 'bars' ? ' menu' : '')} onClick={leftClickHandler}>
          {leftIcon && <Icon src={leftIcon} height="20px" />}
        </div>
      )}
      <span className="title">{title}</span>
      <div className="right">{rightButton as ReactElement}</div>
    </div>
  );
};

export default TopBar;
